import { useSnackbar } from 'notistack';
import { useMutation, useQueryClient } from 'react-query';
import { ContractDocument } from 'shared/types';
import { useService } from 'shared/providers';

export function useUpdateDraftContract() {
  const { draftContractService } = useService();
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  const mutation = useMutation<{ operationId: string }, Error, ContractDocument>(
    request => draftContractService.updateDraftContract(request),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('draft-contract');
      },
      onError: () => {
        enqueueSnackbar('Draft contract was not updated', { variant: 'error' });
      },
    }
  );

  return mutation;
}
